module.exports = __webpack_public_path__ + "assets/cover_6_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_6_old.jpg
 ** module id = 211
 ** module chunks = 1
 **/